import call from "@kinetics254/cassandra-base/service/http";
import constants from "./constants";

export default {
    namespaced: true,
    state: {
        transactions: [],
    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        transactionGetter: (state) => (val) => state[val],
    },
    actions: {

    },
};
